import stateMigrationScripts from './stateMigrationScripts/stateMigrationScripts';
import { DataTableConfigBlockState } from './types';

const defaultState: DataTableConfigBlockState = {
    settings: {
        fontSize: 100,
        useFixedOffset: false,
        offsetLeft: 150,
        dayRange: { min: 0, max: 4 },
        dp: 2,
        orientation: 'horizontal',
        showGroupLabels: true,
        rotateVerticalLabels: false,
        binning: false,
        bins: 2,
        headings: [],
        threatLimits: [],
        limits: [],
        directionalVisualization: 'original',
        displayTableHeading: true,
        headerPadding: 15,
        canDownload: false,
    },
    databilities: [],
    version: stateMigrationScripts.length,
};

export default defaultState;
